import { Link } from "react-router-dom";
import { SITE } from "@/lib/api";

const Section = ({ title, children }) => (
  <section className="flex flex-col gap-3">
    <h2 className="font-heading italic text-white text-2xl md:text-3xl tracking-[-0.5px]">{title}</h2>
    <div className="text-sm md:text-base text-white/70 font-body font-light leading-relaxed flex flex-col gap-3">{children}</div>
  </section>
);

const IgLink = () => (
  <a href={SITE.instagram} target="_blank" rel="noopener noreferrer" className="underline hover:text-white">{SITE.instagramHandle}</a>
);

const PRIVACY = [
  ["Titolare del trattamento", <>Il titolare è Francesco Sansone, Via Castellammare 184, Gragnano (NA). Per domande sull'uso dei tuoi dati puoi scrivere a <a href={`mailto:${SITE.email}`} className="underline hover:text-white">{SITE.email}</a>.</>],
  ["Quali dati raccogliamo", "Con il modulo di prenotazione raccogliamo nome, cognome, numero di telefono, anno di nascita e la lista scelta."],
  ["Perché li usiamo", <>
    <p>Usiamo questi dati per gestire la tua prenotazione e la lista d'ingresso della serata, cioè per fornirti il servizio che hai richiesto.</p>
    <p>Il numero di telefono serve anche per contattarti con promozioni sui prossimi eventi (SMS o WhatsApp) <strong className="text-white font-medium">solo se hai spuntato l'apposito consenso</strong>. Il consenso è facoltativo, non è necessario per prenotare e puoi ritirarlo quando vuoi.</p>
  </>],
  ["Dove sono conservati", "I dati vengono salvati in un archivio protetto collegato a questo sito, accessibile solo allo staff Eclipsia tramite area riservata con password."],
  ["Per quanto tempo", "Teniamo i dati il tempo necessario a gestire l'evento e li cancelliamo periodicamente dopo la serata, salvo tu abbia dato il consenso a ricevere notizie sui prossimi eventi."],
  ["I tuoi diritti", <>Puoi chiedere in ogni momento di vedere, correggere o cancellare i tuoi dati, opporti al trattamento o revocare il consenso marketing. Scrivici su Instagram (<IgLink />) o all'email indicata sopra.</>],
  ["Minori", "I nostri eventi sono riservati ai maggiorenni: all'ingresso viene richiesto un documento d'identità."],
];

const COOKIE = [
  ["Cookie sul sito pubblico", "Le pagine pubbliche di Eclipsia non installano cookie di profilazione, di statistica o pubblicitari, e non usano strumenti di tracciamento come Google Analytics o Facebook Pixel."],
  ["Area riservata", "Solo l'area di amministrazione usata dallo staff imposta cookie tecnici di sessione, necessari per l'accesso con password. Non riguardano i visitatori del sito."],
  ["Risorse esterne", "Il sito carica i caratteri tipografici da Google Fonts (fonts.googleapis.com). Il fornitore può registrare l'indirizzo IP per far funzionare la propria rete, ma non installa cookie tramite il nostro sito."],
  ["Modifiche", "Se in futuro introdurremo cookie statistici o pubblicitari, aggiorneremo questa pagina e chiederemo prima il tuo consenso con un apposito banner."],
  ["Contatti", <>Per domande scrivici su Instagram (<IgLink />). Per il trattamento dei dati personali leggi la <Link to="/privacy" className="underline hover:text-white">Privacy Policy</Link>.</>],
];

export default function Legal({ kind }) {
  const isPrivacy = kind === "privacy";
  const sections = isPrivacy ? PRIVACY : COOKIE;
  return (
    <main className="min-h-screen bg-black px-6 py-12" data-testid={`${kind}-page`}>
      <div className="max-w-2xl mx-auto flex flex-col gap-10">
        <Link to="/" data-testid="legal-logo-link"><img src={SITE.logo} alt="Eclipsia" className="h-14 w-auto" /></Link>
        <header>
          <p className="text-xs tracking-[0.3em] uppercase text-white/50 font-body font-medium mb-3">Informativa</p>
          <h1 className="font-heading italic font-normal text-white text-5xl md:text-6xl tracking-[-2px]">{isPrivacy ? "Privacy Policy" : "Cookie Policy"}</h1>
        </header>
        {sections.map(([title, body]) => (
          <Section key={title} title={title}>{typeof body === "string" ? <p>{body}</p> : body}</Section>
        ))}
        <Link to="/" data-testid="legal-back-home" className="glass rounded-full px-5 py-2.5 self-start text-sm text-white/80 hover:text-white font-body transition-colors">← Torna alla home</Link>
      </div>
    </main>
  );
}
